// @flow

export const sum = (a: number, b: number) => a + b;
export const foldIntoObject = (object: Object, entry: Object) => ({ ...object, ...entry });
